<template>
  <div class="AddProduction">
    <div class="titleBox">
      <el-page-header v-if="isAdd" @back="goBack" :content="isAddContent">
      </el-page-header>
      <el-page-header v-else @back="goBack" :content="isEditContent">
      </el-page-header>
    </div>
    <div class="contentBox">
      <AppBox class="selectBox">
        <b>选择系列</b>
        <div class="itemBtn" @click="handleSelectSeries">
          +选择系列打包
        </div>
        <div class="activeBtn" @click="handleSelectCourse">
          +选择课程打包
        </div>
        <div class="selectBtn" @click="handleSelectExam">+打包试卷</div>
        <el-divider></el-divider>
        <div class="seriesListBox">
          <div
              v-for="(item, index) in this.formData.productSubjects"
              :key="index"
              @click="handleContent(index)"
          >
            <div :class="['itemBox','activeBox','selectBox'][item.type]">
              {{ item.classSubjectName }}
              <div class="tool-box">
                <i v-if="formData.type===3"
                   class="el-icon-s-tools"
                   @click.stop="handleOpenToolDialog(item)"
                ></i>
                <i
                    class="el-icon-error"
                    @click.stop="handleDeleteSeries(item)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </AppBox>
      <el-form ref="form" :model="formData" :rules="rules" label-width="90px">
        <AppBox class="baseInfo">
          <div class="boxLine">
            <b>基础信息</b>
            <el-divider></el-divider>

            <el-form-item label="课包类型:" prop="type">
              <el-select
                  v-model="formData.type"
                  filterable
                  placeholder="请选择"
                  style="width: 20%"
              >
                <el-option
                    v-for="item in productionType"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="课包分类:" prop="category">
              <el-select
                  v-model="formData.category"
                  filterable
                  placeholder="请选择"
                  style="width: 20%"
              >
                <el-option
                    v-for="item in productionTypeOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <div class="inlineRow">
              <el-form-item label="课包名称:" prop="name">
                <el-input v-model="formData.name"></el-input>
              </el-form-item>
              <el-form-item label="特别说明:">
                <el-input v-model="formData.description"></el-input>
              </el-form-item>
              <el-form-item label="课包标签:">
                <AppTreeSelect
                    :options="options"
                    :valueArr="formData.tagValueIdList"
                    @tagChange="tagChange"
                ></AppTreeSelect>
                <!--                <el-input v-model="formData.tag"></el-input>-->
              </el-form-item>
            </div>
            <el-form-item label="主讲老师:" prop="nicknames">
              <el-input
                  style="width: 150px"
                  v-model="formData.nicknames[0]"
              ></el-input>
              <el-input
                  style="width: 150px; margin-left: 20px"
                  v-model="formData.nicknames[1]"
              ></el-input>
              <el-input
                  style="width: 150px; margin-left: 20px"
                  v-model="formData.nicknames[2]"
              ></el-input>
              <el-input
                  style="width: 150px; margin-left: 20px"
                  v-model="formData.nicknames[3]"
              ></el-input>
              <el-input
                  style="width: 150px; margin-left: 20px"
                  v-model="formData.nicknames[4]"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="课包封面:"
                prop="materialUrl"
                :show-message="showMaterialUrlError"
            >
              <template v-if="!formData.materialUrl">
                <div class="productionImgBox" @click="handleUploadProductImg">
                  <i class="el-icon-plus"></i>
                </div>
              </template>
              <template v-else>
                <div style="display: flex; align-items: flex-end">
                  <img
                      style="height: 112px; width: 160px; margin-right: 20px"
                      :src="formData.materialUrl"
                      alt=""
                  />
                  <el-button
                      type="primary"
                      size="mini"
                      @click="handleUploadProductImg"
                  >更换封面
                  </el-button>
                </div>
              </template>
            </el-form-item>
            <el-form-item
                class="editorBox"
                label="音频介绍:"
                v-loading="loading"
                element-loading-text="音频正在生成中，请勿操作..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
            >
              <quill-editor
                  ref="quillEditor"
                  :class="
                  warning || blankWarning ? 'warningEditor' : 'defaultEditor'
                "
                  :options="editorOptions"
                  v-model="formData.introduce.audioText"
                  @change="handleChange"
              ></quill-editor>
              <div v-if="warning" class="warningTxt">
                转音频文字不得超过300字
              </div>
              <div v-if="blankWarning" class="warningTxt">请输入</div>
            </el-form-item>
            <el-form-item label="">
              <div class="toolsBox">
                <!--            左边部分-->
                <div>
                  <!--                  声音属性-->
                  <div>
                    <span>声音属性： </span>
                    <el-radio-group v-model="formData.introduce.voice">
                      <el-radio
                          v-for="item in humanOption"
                          :key="item.value"
                          :label="item.value"
                      >{{ item.label }}
                      </el-radio>
                    </el-radio-group>
                  </div>
                  <!--              播放速度-->
                  <div>
                    <span>播放速度： </span>
                    <el-radio-group v-model="formData.introduce.speechRate">
                      <el-radio
                          v-for="item in rateArr"
                          :key="item.value"
                          :label="item.value"
                      >{{ item.label }}
                      </el-radio>
                    </el-radio-group>
                  </div>
                  <!--              音频组件-->
                  <div class="audioBox" v-if="formData.introduce.materialUrl">
                    <div>
                      <audio
                          :src="formData.introduce.materialUrl"
                          :loop="false"
                          controls
                          preload="auto"
                          ref="audioRef"
                      ></audio>
                    </div>
                    <div style="margin-left: 10px">
                      <el-button
                          size="mini"
                          type="primary"
                          @click="handleDeleteAudio"
                      >清除音频
                      </el-button>
                    </div>
                  </div>
                </div>
                <!--            右边按钮-->
                <div>
                  <el-button
                      size="mini"
                      type="primary"
                      @click="handlePolyPhoneModal"
                  >多音字
                  </el-button>
                  <el-button
                      size="mini"
                      type="primary"
                      @click="handleCreatAudio"
                  >生成音频
                  </el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="课程说明:" prop="text">
              <el-input
                  type="textarea"
                  style="width: 80%"
                  v-model="formData.text"
              ></el-input>
            </el-form-item>
            <el-form-item
                :style="{ height: imgLoading ? '110px' : '' }"
                label=""
                v-loading="imgLoading"
                element-loading-text="图片正在上传中，请勿操作..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
            >
              <el-upload
                  v-if="!imgLoading"
                  :class="
                  formData.imageList && formData.imageList.length >= 6
                    ? 'uploadDisabledCss'
                    : ''
                "
                  action="#"
                  list-type="picture-card"
                  :file-list="formData.imageList"
                  :multiple="true"
                  :auto-upload="false"
                  :limit="6"
                  :on-exceed="onExceed"
                  :on-change="handleImgChange"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.materialUrl || file.src"
                      alt=""
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <MaterialPicker
                  materialType="image"
                  @onConfirmPickMaterial="onConfirmPickMaterial"
              ></MaterialPicker>
            </el-form-item>
          </div>
          <div class="productionInfo" v-show="permissionCode.has('research:product:price')">
            <b>课包信息</b>
            <el-divider></el-divider>
            <div>
              <el-form-item label="企业可购:">
                <el-checkbox v-model="formData.commercial">
                </el-checkbox>
              </el-form-item>
              <el-form-item label="企业价:">
                <el-input-number
                    v-model="formData.buyOutPrice"
                    :precision="2"
                    :step="1"
                    :min="0"
                ></el-input-number>
                元
              </el-form-item>

            </div>
            <el-form-item label="付费方式:" prop="paymentMethod">
              <el-radio-group v-model="formData.paymentMethod">
                <el-radio
                    v-for="item in payOptions"
                    :key="item.value"
                    :label="item.value"
                >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="payBox" v-if="formData.paymentMethod === 1">
              <el-form-item label="市场价:">
                <el-input-number
                    v-model="formData.total"
                    :precision="2"
                    :step="1"
                    :min="0"
                ></el-input-number>
                元
              </el-form-item>
              <el-form-item label="销售价:" prop="salePrice">
                <el-input-number
                    v-model="formData.salePrice"
                    :precision="2"
                    :step="1"
                    :min="0.01"
                ></el-input-number>
                元
              </el-form-item>
              <el-form-item label="有效期:" prop="validityType">
                <el-radio-group v-model="formData.validityType">
                  <el-radio
                      v-for="item in lifeOptions"
                      :key="item.value"
                      :label="item.value"
                  >{{ item.label }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <div
                  style="
                  border-radius: 8px;
                  background-color: #ffffff;
                  padding: 15px;
                  margin: 10px;
                "
              >
                营销活动
                <el-divider></el-divider>
                <el-form-item label-width="20px">
                  <el-checkbox
                      v-model="formData.groupPurchase"
                      @change="changeGroupPurchase"
                  >多人团购
                  </el-checkbox>
                </el-form-item>
                <div
                    class="inlineRow"
                    v-for="(item, index) in formData.groupPurchaseDataList"
                    :key="index"
                >
                  <el-form-item label="">
                    <span style="color: #f56c6c; margin-right: 5px">*</span>
                    <el-input-number
                        v-model="formData.groupPurchaseDataList[index].groupSize"
                        :precision="0"
                        :step="1"
                        :min="2"
                        :max="6"
                        size="small"
                    ></el-input-number>
                    人团购价：
                  </el-form-item>
                  <el-form-item label-width="0">
                    <el-input-number
                        v-model="formData.groupPurchaseDataList[index].salePrice"
                        :precision="2"
                        :step="1"
                        :min="0.01"
                        size="small"
                    ></el-input-number>
                    元
                  </el-form-item>
                  <!--                  <el-form-item-->
                  <!--                    label-width="0"-->
                  <!--                    v-if="-->
                  <!--                      index === 0 && formData.groupPurchaseDataList.length === 1-->
                  <!--                    "-->
                  <!--                  >-->
                  <!--                    <div @click="handleCopy(item)">-->
                  <!--                      <img-->
                  <!--                        style="width: 20px; margin-left: 25px; cursor: pointer"-->
                  <!--                        class="el-upload-list__item-thumbnail"-->
                  <!--                        src="../../assets/png/copyDown.png"-->
                  <!--                        alt=""-->
                  <!--                      />-->
                  <!--                      <span class="btnTxt">点击向下复制</span>-->
                  <!--                    </div>-->
                  <!--                  </el-form-item>-->
                  <!--                  <el-form-item label-width="0" v-if="index !== 0">-->
                  <!--                    <div @click="handleDelete(index)">-->
                  <!--                      <img-->
                  <!--                        style="width: 18px; margin-left: 25px; cursor: pointer"-->
                  <!--                        class="el-upload-list__item-thumbnail"-->
                  <!--                        src="../../assets/png/cancel.png"-->
                  <!--                        alt=""-->
                  <!--                      />-->
                  <!--                      <span class="btnTxt">点击取消此条</span>-->
                  <!--                    </div>-->
                  <!--                  </el-form-item>-->
                </div>
                <el-form-item label="团购有效期：" label-width="190px">
                  <el-select
                      v-model="formData.groupPurchaseDataList[0].expiredTime"
                      filterable
                      style="width: 60px"
                      size="mini"
                      @change="handleChangeExpiredTime"
                  >
                    <el-option
                        v-for="item in expiredTimeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  小时
                </el-form-item>
                <el-form-item label-width="20px">
                  <el-checkbox
                      :value="formData.allowable"
                      :true-label="1"
                      :false-label="0"
                      @change="changeAllowAble"
                  >首单优惠
                  </el-checkbox>
                </el-form-item>
                <el-form-item label-width="90px">
                  立享
                  <el-input-number
                      v-model="formData.discount"
                      :precision="1"
                      :step="1"
                      :min="0.1"
                      :max="10"
                      size="small"
                  ></el-input-number>
                  折
                </el-form-item>
              </div>
              <!--              <el-form-item label="是否参与折扣优惠:" label-width="150px">-->
              <!--                <el-switch-->
              <!--                  v-model="formData.allowable"-->
              <!--                  :active-value="1"-->
              <!--                  active-color="#EC7015"-->
              <!--                  :inactive-value="0"-->
              <!--                  inactive-color="#C0CCDA"-->
              <!--                >-->
              <!--                </el-switch>-->
              <!--              </el-form-item>-->
            </div>
          </div>
          <div class="footer">
            <el-button
                :loading="loadingSubmit"
                style="width: 150px"
                type="primary"
                @click="handleConfirm"
            >保存
            </el-button>
            <el-button
                :loading="loadingSubmit"
                style="width: 150px"
                type="primary"
                @click="handleSaveUp"
            >保存并发布
            </el-button>
          </div>
        </AppBox>
      </el-form>
      <CorrectPolyPhoneModal
          @refreshInputVal="refreshInputVal"
          :inputValArr="inputValArr"
      ></CorrectPolyPhoneModal>
      <SeriesListModal
          @selectedProductSubjects="selectedProductSubjects"
          :states="1"
      ></SeriesListModal>
      <CourseListModal
          @selectedProductCourse="selectedProductCourse"
      ></CourseListModal>
      <ExamListModal
          @selectedProductCourse="selectedProductCourse"
      ></ExamListModal>
      <AppSelectCoverImgModal
          :imageUrl="formData.materialUrl"
          @productMaterialUrlChange="productMaterialUrlChange"
      ></AppSelectCoverImgModal>
      <SubjectContentListModal
          @handleSortSuccess="handleSortSuccess"
      ></SubjectContentListModal>
      <ExamContentListModal
          @handleSortSuccess="handleSortSuccess"
      ></ExamContentListModal>
      <ProductSubjectToolModal ref="tool"></ProductSubjectToolModal>
    </div>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import {productionMixins} from "@/pages/ProductionManagement/productionMixins";
import {quillEditor} from "vue-quill-editor";
import {mapActions, mapMutations, mapState} from "vuex";
import CorrectPolyPhoneModal from "@/pages/ProductionManagement/CorrectPolyPhoneModal.vue";
import SeriesListModal from "@/pages/ProductionManagement/SeriesListModal.vue";
import CourseListModal from "@/pages/ProductionManagement/CourseListModal.vue";
import AppSelectCoverImgModal from "@/components/ui/AppSelectCoverImgModal/index.vue";
import SubjectContentListModal from "@/pages/ProductionManagement/SubjectContentListModal.vue";
import ExamListModal from "@/pages/ProductionManagement/ExamListModal.vue";
import ExamContentListModal from "@/pages/ProductionManagement/ExamContentListModal.vue";
import AppTreeSelect from "@/components/ui/AppTreeSelect/index.vue";
import MaterialPicker from "@/pages/MaterialCenter/components/MaterialPicker.vue";
import ProductSubjectToolModal from "@/pages/ProductionManagement/ProductSubjectToolModal.vue";

export default {
  name: "AddProduction",
  components: {
    ProductSubjectToolModal,
    MaterialPicker,
    AppTreeSelect,
    ExamContentListModal,
    ExamListModal,
    SubjectContentListModal,
    AppSelectCoverImgModal,
    CourseListModal,
    SeriesListModal,
    CorrectPolyPhoneModal,
    AppBox,
    quillEditor,
  },
  mixins: [productionMixins],
  data() {
    return {
      isAdd: true,
      isAddContent: "课包管理 | 发布课包",
      isEditContent: "课包管理 | 编辑课包",
      // 多音字开始
      editorOptions: {
        placeholder: "请输入你的内容，选择要展示的性别属性，点击生成音频",
      },
      humanOption: [
        {
          label: "老师",
          value: "zhiyuan",
        },
        {
          label: "学生",
          value: "zhigui",
        },
        {
          label: "标准女生",
          value: "sijia",
        },
        {
          label: "沉稳男生",
          value: "stanley",
        },
      ],
      rateArr: [
        {
          label: "慢",
          value: 0.8,
        },
        {
          label: "正常",
          value: 1.0,
        },
        {
          label: "快",
          value: 1.2,
        },
      ],
      inputValArr: [],
      textLength: null,
      warning: false,
      blankWarning: false,
      loading: false,
      loadingSubmit: false,
      index: null,
      showMaterialUrlError: true,
      // 多音字结束
      productionTypeOption: [],
      productionType: [
        {id: 0, name: "正常课程"},
        {id: 3, name: "计划课程"},
      ],
      payOptions: [
        {
          value: 0,
          label: "免费学习",
        },
        {
          value: 1,
          label: "付费学习",
        },
      ],
      imgLoading: false,
      lifeOptions: [
        {
          value: 0,
          label: "永久有效",
        },
      ],
      expiredTimeOption: [
        {
          value: 43200000,
          label: "12",
        },
        {
          value: 86400000,
          label: "24",
        },
        {
          value: 129600000,
          label: "36",
        },
        {
          value: 172800000,
          label: "48",
        },
        {
          value: 259200000,
          label: "72",
        },
      ],
    };
  },
  computed: {
    ...mapState("app", ["appSelectCoverImgModalVisible"]),
    ...mapState("courseCenter", ["audioDetail", "tagCategoryList"]),
    ...mapState("tenant", ["ossUploadObj"]),
    ...mapState("polyPhone", ["polyPhoneModalVisible"]),
    ...mapState("user", ["permissionCode"]),
    ...mapState("teachingCenter", [
      "selectSeriesModalVisible",
      "selectCourseModalVisible",
      "selectExamModalVisible",
      "productSubjects",
      "subjectContentListModalVisible",
      "examContentListModalVisible",
      // "isBack",
    ]),
  },
  watch: {
    textLength: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.warning = newValue > 300;
          this.blankWarning = newValue === 0;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    this.productionTypeOption = await this.getCachedProductCategoryList();
    await this.getTagCategoryList({
      includeChild: true,
      page: 1,
      size: 10000,
    });
    this.options = this.tagCategoryList.data;
    if (this.$route.params.type === "add") {
      this.clearForm();
      this.isAdd = true;
    }
    if (this.$route.params.type === "edit") {
      this.clearForm();
      let productDetail = JSON.parse(localStorage.getItem("productDetail"));
      Object.keys(this.formData).map((key) => {
        this.formData[key] = productDetail[key];
      });
      if (!productDetail.imageList) {
        this.formData.imageList = [];
      }
      if (!productDetail.productSubjects) {
        this.formData.productSubjects = [];
      }
      if (!productDetail.nicknames) {
        this.formData.nicknames = [];
      }
      this.formData.salePrice = this.price(this.formData.salePrice);
      this.formData.total = this.price(this.formData.total);
      this.formData.buyOutPrice = this.price(this.formData.buyOutPrice);
      if (this.formData.groupPurchaseDataList.length > 0) {
        this.formData.groupPurchaseDataList.forEach((item) => {
          // item.expiredTime = item.expiredTime * 1000 * 60 * 60;
          item.salePrice = this.price(item.salePrice);
        });
      } else {
        this.formData.groupPurchaseDataList = [
          {
            expiredTime: 43200000,
            groupSize: null,
            id: null,
            productId: null,
            salePrice: null,
          },
        ];
      }
      this.isAdd = false;
      this.disabledEdit();
      this.blurEditor();
    }
  },
  methods: {
    ...mapMutations("polyPhone", ["distinguishSetData"]),
    ...mapActions("courseCenter", ["getAudioUrl", "getTagCategoryList"]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    ...mapMutations("teachingCenter", ["setData"]),
    ...mapActions("teachingCenter", ["getCachedProductCategoryList"]),
    ...mapMutations("app", ["setDataModal"]),
    goBack() {
      // this.setData({key: "isBack", value: true});
      this.$router.go(-1);
    },
    handleChangeExpiredTime(val) {
      this.formData.groupPurchaseDataList.forEach((item) => {
        item.expiredTime = val;
      });
    },
    price(val) {
      if (!val) {
        return null;
      } else {
        return val / 100;
      }
    },
    tagChange(val) {
      this.formData.tagValueIdList = val;
    },
    // 向下复制
    handleCopy(item) {
      let newItem = {
        expiredTime: item.expiredTime,
        groupSize: null,
        id: null,
        productId: null,
        salePrice: null,
      };
      this.formData.groupPurchaseDataList.push(newItem);
      newItem = null;
    },
    handleDelete(idx) {
      this.formData.groupPurchaseDataList.splice(idx, 1);
    },
    // 选择系列
    async handleSelectSeries() {
      this.setData({
        key: "productSubjects",
        value: this.formData.productSubjects,
      });
      this.setData({key: "selectSeriesModalVisible", value: true});
      this.$store.state.teachingCenter.seriesListFilter.states = 1;
    },
    // 已经选择的系列，来自于弹框数据
    selectedProductSubjects(val) {
      this.formData.productSubjects = val;
    },
    handleOpenToolDialog(row) {
      this.$refs.tool.visible = true;
      this.$refs.tool.initData(row);
    },
    // 删除系列
    handleDeleteSeries(row) {
      if (row.classSubjectId) {
        this.formData.productSubjects = this.formData.productSubjects.filter(
            (item) => item.classSubjectId !== row.classSubjectId
        );
      } else {
        this.formData.productSubjects = this.formData.productSubjects.filter(
            (item) => item.id !== row.id
        );
      }
    },
    handleContent(index) {
      this.index = index;
      this.setData({
        key: "subjectContentListFilter",
        value: this.formData.productSubjects[index],
      });
      if (
          this.formData.productSubjects[index].type &&
          this.formData.productSubjects[index].type === 2
      ) {
        this.setData({key: "examContentListModalVisible", value: true});
      } else {
        this.setData({key: "subjectContentListModalVisible", value: true});
      }
    },
    // 接收排过序的数组
    handleSortSuccess(val) {
      this.formData.productSubjects[this.index] = val;
      this.index = null;
    },
    // 选择课程
    async handleSelectCourse() {
      await this.getTagCategoryList({
        includeChild: true,
        page: 1,
        size: 10000,
      });
      this.setData({key: "selectCourseModalVisible", value: true});
    },
    // 选择试卷
    handleSelectExam() {
      this.setData({key: "selectExamModalVisible", value: true});
    },
    selectedProductCourse(val) {
      this.formData.productSubjects.push(val);
    },
    onConfirmPickMaterial(item) {
      this.formData.imageList.push({
        materialId: item.id,
        materialUrl: item.url,
      });
    },
    // 上传课包封面图
    handleUploadProductImg() {
      this.setDataModal({
        key: "appSelectCoverImgModalVisible",
        value: true,
      });
    },
    // 封面图更换
    productMaterialUrlChange(val) {
      this.formData.materialUrl = val;
      this.showMaterialUrlError = false;
    },
    // 上传图片
    async handleImgChange(file) {
      this.imgLoading = true;
      const isJPG =
          file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG!");
        this.imgLoading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then(() => {
            let newImgObjArr = {
              filename: this.ossUploadObj.filename,
              materialId: null,
              materialUrl: URL.createObjectURL(file.raw),
            };
            this.formData.imageList.push(newImgObjArr);
            newImgObjArr = null;
            this.imgLoading = false;
          })
          .catch(() => {
            this.imgLoading = false;
            this.$message.error("图片上传失败，请重新上传");
            this.formData.imageList = this.formData.imageList.filter(
                (item) => item.uid !== file.uid
            );
          });
      this.$axios.defaults.withCredentials = true;
    },
    // 删除图片
    handleRemove(file) {
      this.formData.imageList = this.formData.imageList.filter(
          (item) => item.uid !== file.uid
      );
    },
    // 图片数量超出
    onExceed() {
      this.$message.warning("图片最多不能超过6张");
    },
    // 多音字开始
    // 内容输入框change事件
    handleChange() {
      this.inputValArr = this.convertToObjects(
          this.formData.introduce.audioText
      );
      this.textLength = this.inputValArr.length;
      this.$nextTick(() => {
        this.disabledEdit();
      });
    },
    // 清除音频
    handleDeleteAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.introduce.audioText = "";
            this.formData.introduce.audioSsmlText = "";
            this.formData.introduce.materialUrl = "";
            this.formData.introduce.filename = "";
            this.formData.introduce.speechRate = 1.0;
            this.formData.introduce.voice = "zhiyuan";
          })
          .catch(() => {
          });
    },
    // 生成音频
    async handleCreatAudio() {
      // 生成拼音汉字对象数组
      this.inputValArr = this.convertToObjects(
          this.formData.introduce.audioText
      );
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.loading = true;
      // 生成富文本样式
      const inputText = this.creatQuillText(this.inputValArr);
      // 回显到input输入框
      this.refreshInputVal(inputText);
      //   生成ssml文本
      this.formData.introduce.audioSsmlText = this.creatSsmlText(
          this.inputValArr
      );
      // 调接口生成音频
      try {
        await this.getAudioUrl({
          text: this.formData.introduce.audioSsmlText,
          speechRate: this.formData.introduce.speechRate,
          voice: this.formData.introduce.voice,
        });
        // 媒体名称
        this.formData.introduce.filename = this.audioDetail.filename;
        // 媒体ID
        this.formData.introduce.materialId = this.audioDetail.materialId;
        // 媒体url
        this.formData.introduce.materialUrl = this.audioDetail.url;
      } finally {
        this.loading = false;
      }
    },
    // 打开多音字弹窗
    handlePolyPhoneModal() {
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.inputValArr = this.convertToObjects(
          this.formData.introduce.audioText
      );
      this.distinguishSetData({key: "polyPhoneModalVisible", value: true});
    },
    // 选择多音字发音弹框确定按钮传过来的富文本编辑器回显inputVal
    refreshInputVal(audioText) {
      this.formData.introduce.audioText = audioText;
      this.$nextTick(() => {
        this.disabledEdit();
        this.blurEditor();
      });
    },
    // 解析为富文本
    creatQuillText(val) {
      return val
          .map((item, index) => {
            if (item.pinyin !== "") {
              if (index % 2 === 0) {
                return `<b style='color: #10689c;'> [${item.pinyin}]${item.cha} </b>`;
              } else {
                return `<b style='color: #10689c;background: transparent;'> [${item.pinyin}]${item.cha} </b>`;
              }
            } else {
              if (item.cha === " ") {
                return "&nbsp;";
              } else {
                return item.cha;
              }
            }
          })
          .join("");
    },
    // 解析为ssml文本，生成音频
    creatSsmlText(val) {
      const ssmlText = val
          .map((item) => {
            if (item.pinyin !== "") {
              return `<phoneme alphabet='py' ph='${item.pinyin}'>${item.cha}</phoneme>`;
            } else {
              return item.cha;
            }
          })
          .join("");
      return "<speak>" + ssmlText + "</speak>";
    },
    // 返回纯文本数组
    convertToObjects(val) {
      let objects = [];
      if (!val) {
        return objects;
      }
      const regex = /(<strong.*?>.*?<\/strong>)|./g;
      const result = val.match(regex);
      var newResult = [];
      for (let i = 0; i < result.length; i++) {
        if (result[i].trim().length > 1) {
          if (!result[i].includes("color: rgb(16, 104, 156)")) {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push(text);
          } else {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push("{{{" + text + "}}}");
          }
        } else {
          newResult.push(result[i]);
        }
      }
      const str = newResult.join("");
      const div = document.createElement("div");
      div.innerHTML = str;
      let newStr = div.textContent || div.innerText;

      const regex2 = /({{{.*?}}})|./g;
      const result2 = newStr.match(regex2);
      for (let i = 0; i < result2.length; i++) {
        const item = result2[i];
        if (item.length > 1) {
          const regex = /{{{(.+?)}}}/g;
          const match = item.replace(regex, "$1");
          if (match && match.length >= 2) {
            const extractedText = match.trim();
            const cha = extractedText.split("]")[1];
            const pinyin = extractedText.split("]")[0].split("[")[1];
            objects.push({cha: cha, pinyin: pinyin});
          }
        } else {
          objects.push({cha: item, pinyin: ""});
        }
      }
      if (objects.every((item) => item.cha === " ")) {
        objects = [];
      }
      return objects;
    },
    // 多音字不可编辑部分
    disabledEdit() {
      let paragraphs = document.querySelectorAll("p");
      paragraphs.forEach(function (paragraph) {
        let strongArr = paragraph.querySelectorAll("strong");
        strongArr.forEach(function (strong) {
          strong.setAttribute("contenteditable", "false");
        });
      });
    },
    //   输入框失去焦点
    blurEditor() {
      this.$nextTick(() => {
        const editor = this.$refs.quillEditor.quill;
        const length = editor.getLength();
        editor.setSelection(length, length);
        editor.blur();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.AddProduction {
  .titleBox {
    background: white;
    border-radius: 2px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ::v-deep .el-page-header__left {
      color: map-get($colors, primary);
    }
  }

  .contentBox {
    width: 100%;
    height: calc(100vh - 155px);
    overflow-y: auto;

    .selectBox {
      margin-bottom: 20px;

      b {
        font-size: 18px;
      }

      .itemBtn {
        border: 1px solid #10689c;
        color: #10689c;
        display: inline-block;
        padding: 10px 20px;
        font-size: 17px;
        border-radius: 6px;
        margin-left: 30px;
        cursor: pointer;
      }

      .activeBtn {
        border: 1px solid #ea5514;
        color: #ea5514;
        display: inline-block;
        padding: 10px 20px;
        font-size: 17px;
        border-radius: 6px;
        margin-left: 30px;
        cursor: pointer;
      }

      .selectBtn {
        border: 1px solid #5467ff;
        color: #5467ff;
        display: inline-block;
        padding: 10px 20px;
        font-size: 17px;
        border-radius: 6px;
        margin-left: 30px;
        cursor: pointer;
      }

      .seriesListBox {
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        .itemBox {
          width: 200px;
          text-align: center;
          padding: 15px 10px;
          background: #10689c;
          color: #ffffff;
          border-radius: 6px;
          position: relative;
          margin: 12px;
          font-size: 16px;
          cursor: pointer;
        }

        .activeBox {
          width: 200px;
          text-align: center;
          padding: 15px 10px;
          background: #ea5514;
          color: #ffffff;
          border-radius: 6px;
          position: relative;
          margin: 12px;
          font-size: 16px;
          cursor: pointer;
        }

        .selectBox {
          width: 200px;
          text-align: center;
          padding: 15px 10px;
          background: #5467ff;
          color: #ffffff;
          border-radius: 6px;
          position: relative;
          margin: 12px;
          font-size: 16px;
          cursor: pointer;
        }

        .tool-box {
          position: absolute;
          right: 1px;
          top: 3px;
          font-size: 18px;
          cursor: pointer;
        }
      }
    }

    .baseInfo {
      b {
        font-size: 18px;
      }

      .boxLine {
        border: 1px solid #dcdfe6;
        padding: 20px;
        border-radius: 6px;
        margin-bottom: 40px;

        .inlineRow {
          width: 100%;

          ::v-deep .el-form-item {
            display: inline-block;
            width: 31%;
          }
        }

        .productionImgBox {
          border-radius: 2px;
          border: 1px solid #dcdfe6;
          width: 160px;
          height: 112px;
          text-align: center;
          cursor: pointer;

          .el-icon-plus {
            color: #dcdfe6;
            font-size: 25px;
            line-height: 112px;
          }
        }

        //多音字开始
        .editorBox {
          ::v-deep .el-form-item__label::before {
            content: "*";
            color: #f56c6c;
            margin-right: 4px;
          }
        }

        ::v-deep .ql-toolbar.ql-snow {
          display: none;
        }

        ::v-deep .ql-container.ql-snow {
          border: none;
        }

        ::v-deep .ql-editor {
          width: 100%;
          border: none;
          border-radius: 4px;
          height: 150px !important;
          background: #ffffff;
        }

        ::v-deep .defaultEditor {
          width: 80%;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
        }

        ::v-deep .warningEditor {
          width: 80%;
          border-radius: 4px;
          border: 1px solid #f56c6c;
        }

        .warningTxt {
          color: #f56c6c;
          font-size: 12px;
        }

        ::v-deep .ql-editor.ql-blank::before {
          color: #c0c4cc;
          content: attr(data-placeholder);
          font-style: normal;
          font-size: 12px;
          left: 15px;
          pointer-events: none;
          position: absolute;
          right: 15px;
        }

        .toolsBox {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          width: 80%;

          ::v-deep audio {
            margin-top: 10px;
            height: 35px;
            width: 270px;
          }

          .audioBox {
            margin-top: 10px;
            line-height: 35px;
            height: 35px;
            display: flex;
            align-items: center;
          }
        }

        //多音字结束

        ::v-deep .el-textarea__inner {
          min-height: 150px !important;
        }

        .el-upload-list__item-thumbnail {
          width: 158px;
          height: 110px;
        }

        .uploadDisabledCss {
          //超出6张不显示上传框
          ::v-deep .el-upload--picture-card {
            display: none;
          }
        }

        //.el {
        //默认上传框
        ::v-deep .el-upload--picture-card {
          width: 158px;
          height: 110px;
          line-height: 110px;
        }

        //}

        //图片列表
        ::v-deep .el-upload-list__item {
          width: 158px;
          height: 110px;
          line-height: 110px;
        }
      }
    }

    .productionInfo {
      border: 1px solid #dcdfe6;
      padding: 20px;
      border-radius: 6px;

      b {
        font-size: 18px;
      }

      .payBox {
        width: 80%;
        padding: 20px 0 5px 0;
        background: #f2f2f2;
        border-radius: 3px;
        margin: 0 0 10px 10px;

        .inlineRow {
          //width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          ::v-deep .el-form-item__content {
            display: flex;
            align-items: center;
          }

          .btnTxt {
            color: #10689c;
            font-size: 12px;
            cursor: pointer;
          }
        }
      }
    }

    .footer {
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>
